// extracted by mini-css-extract-plugin
export var avatarContainer = "_59-0";
export var avatarTypingWave = "_59-i";
export var gray = "_59-f";
export var green = "_59-c";
export var icon = "_59-9";
export var image = "_59-1";
export var lg = "_59-6";
export var md = "_59-5";
export var presenceDot = "_59-b";
export var red = "_59-d";
export var sm = "_59-4";
export var status = "_59-a";
export var typingDot = "_59-h";
export var typingPill = "_59-g";
export var xl = "_59-7";
export var xs = "_59-3";
export var xxl = "_59-8";
export var xxs = "_59-2";
export var yellow = "_59-e";